import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    CreateLogRequestInput,
    LogRequest,
    LogRequestUserMapping,
} from "generated-interfaces/graphql";
import { USER_ACTIONS } from "./userReducer";

export interface RestaurantState {
    logRequestUserMappings: LogRequestUserMapping[];
    selectedLogRequest: LogRequest | null;
    selectedLogRequestLoading: boolean;
}

const initialState: RestaurantState = {
    logRequestUserMappings: [],
    selectedLogRequest: null,
    selectedLogRequestLoading: false,
};

export const fetchLogRequestUserMappings = createAction(
    "FETCH_LOG_REQUEST_USER_MAPPINGS"
);

export const fetchLogRequest = createAction<number>("FETCH_LOG_REQUEST");

export const createLogRequest = createAction<CreateLogRequestInput>(
    "CREATE_LOG_REQUEST"
);

export const logRequestReducer = createSlice({
    name: "logRequest",
    initialState,
    reducers: {
        fetchLogRequestUserMappingSuccess: (
            state,
            action: PayloadAction<LogRequestUserMapping[]>
        ) => {
            state.logRequestUserMappings = action.payload;
        },
        fetchLogRequestLoading: (state) => {
            state.selectedLogRequestLoading = true;
        },
        fetchLogRequestSuccess: (state, action: PayloadAction<LogRequest>) => {
            state.selectedLogRequest = action.payload;
            state.selectedLogRequestLoading = false;
        },
        fetchLogRequestFailed: (state) => {
            state.selectedLogRequestLoading = false;
        },
        createLogRequestLoading: (state) => {
            state.selectedLogRequestLoading = true;
        },
        createLogRequestSuccess: (state, action: PayloadAction<LogRequest>) => {
            state.selectedLogRequest = action.payload;
        },
        createLogRequestFailed: (state) => {
            state.selectedLogRequestLoading = true;
        },
        resetSelectedLogRequest: (state) => {
            state.selectedLogRequest = null;
        },
    },
    extraReducers: {
        [USER_ACTIONS.logout.toString()]: () => {
            return initialState;
        },
    },
});

export const LOG_REQUEST_ACTIONS = logRequestReducer.actions;
